import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { UpdateLocationsFromMlsRequest } from "../../domain";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class UpdateLocationFromMlsUsecase implements UseCase<UpdateLocationsFromMlsRequest, Response> {

  constructor(private readonly locationRepository: LocationsRepository) {
  }

  execute(params: UpdateLocationsFromMlsRequest): Observable<Response> {
    return this.locationRepository.updateLocationFromMls(params);
  }

}
